import React from 'react';

/**
 * IconButton
 * ------------------------------------------------------------------
 * Small circular/rounded-square button that renders a single icon
 * (as an <img>). Used for row-level actions like "edit" and "delete"
 * on EntryCard, but generic enough for any icon-only action.
 *
 * @param {string} iconSrc - path to the icon image
 * @param {string} label - accessible name (rendered visually hidden)
 * @param {'default'|'danger'} tone - color treatment
 */
const IconButton = ({
  iconSrc,
  label,
  tone = 'default',
  size = 'md',
  className = '',
  disabled = false,
  loading = false,
  ...rest
}) => {
  return (
    <button
      type="button"
      className={`amok-icon-btn amok-icon-btn--${tone} amok-icon-btn--${size} ${disabled || loading ? 'amok-icon-btn--disabled' : ''} ${className}`}
      aria-label={label}
      title={label}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? (
        <span className="amok-icon-btn__spinner" aria-hidden="true" />
      ) : (
        <img src={iconSrc} alt="" aria-hidden="true" className="amok-icon-btn__img" />
      )}
    </button>
  );
};

export default IconButton;